import type {
  ButtonHTMLAttributes,
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
} from "react";
import { IconChevronDown } from "./icons";
import "./ui.css";

export function TextField({
  focused,
  leading,
  trailing,
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & {
  focused?: boolean;
  leading?: ReactNode;
  trailing?: ReactNode;
}) {
  return (
    <label className={`tf${focused ? " tf--focus" : ""}${className ? " " + className : ""}`}>
      {leading ? <span className="tf__lead">{leading}</span> : null}
      <input className="tf__input" {...rest} />
      {trailing}
    </label>
  );
}

export function Select({
  placeholder,
  className,
  children,
  value,
  defaultValue,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement> & { placeholder?: string }) {
  const controlled = value !== undefined;
  const selectProps = controlled
    ? { value }
    : { defaultValue: defaultValue ?? "" };
  const currentValue = controlled ? value : defaultValue;
  const hasValue = currentValue !== undefined && currentValue !== "";
  return (
    <div
      className={`tf tf--select${hasValue ? " tf--select-filled" : ""}${className ? " " + className : ""}`}
    >
      <select className="tf__input" {...selectProps} {...rest}>
        {placeholder ? (
          <option value="" disabled>
            {placeholder}
          </option>
        ) : null}
        {children}
      </select>
      <IconChevronDown width={16} height={16} />
    </div>
  );
}

export function PrimaryButton({
  children,
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`btn btn--primary${className ? " " + className : ""}`}
      {...rest}
    >
      {children}
    </button>
  );
}

export function IconButton({
  children,
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`btn btn--icon${className ? " " + className : ""}`}
      {...rest}
    >
      {children}
    </button>
  );
}

export function Helper({ children }: { children: ReactNode }) {
  return <p className="helper">{children}</p>;
}
